/**
 * Asynchronously loads the component for Upskilling
 */

import { lazyLoad } from "utils/loadable";

export const StudentMESPsychometricDetails = lazyLoad(
  () => import("./index"),
  (module) => module.StudentMESPsychometricDetails
);
